import { render } from "./ContenuSecondPanelItem.vue?vue&type=template&id=11a49ca4"
import script from "./ContenuSecondPanelItem.vue?vue&type=script&lang=js"
export * from "./ContenuSecondPanelItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__